import { render, staticRenderFns } from "./MonitorTrashDelete.vue?vue&type=template&id=4156f64c&"
import script from "./MonitorTrashDelete.vue?vue&type=script&lang=js&"
export * from "./MonitorTrashDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports